module.exports = __webpack_public_path__ + "static/media/zdjecia zarzad+koo.92d70dc6.rar";